import { useContext, useMemo } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';
import useRetailer from './useRetailer';
import useAppContext from './useAppContext';

export default function useUserMetaData() {
  const { isSSREnv } = useAppContext();
  const { userData } = useContext(AuthContext);
  const {
    brand,
    merchantId,
    ssSellerId,
    isSSRStore,
    returnsMode,
    getStoreProperty
  } = useRetailer();

  const storeName = getStoreProperty('store_name', '');
  const userRole = isSSRStore ? 'SS-ADMIN' : 'RR-ADMIN';

  return useMemo(() => {
    const userId = _get(userData, 'userId', '');
    const email = _get(userData, 'email', '');
    const firstName = _get(userData, 'firstName', '');
    const lastName = _get(userData, 'lastName', '');

    return {
      group_id: merchantId,
      cx_merchant_id: merchantId,
      customer_id: userId,
      brand,
      email,
      user_id: userId,
      name: `${firstName} ${lastName}`.trim(),
      first_name: firstName,
      last_name: lastName,
      user_role: userRole,
      company_name: storeName,
      seller_id: ssSellerId,
      returns_mode: returnsMode,
      is_SSR_store: isSSRStore,
      is_SSR_environment: isSSREnv
    };
  }, [
    brand,
    userData,
    userRole,
    merchantId,
    storeName,
    ssSellerId,
    returnsMode,
    isSSRStore,
    isSSREnv
  ]);
}
